import {Injectable} from '@angular/core';
import DataSnapshot = firebase.database.DataSnapshot;
import * as firebase from 'firebase';
import {UserModel} from '../models/user.model';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  userSubject = new Subject<UserModel>();
  users: UserModel[] = [];
  public user = null;

  constructor() {
  }

  getUserByUid(uid: string) {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/').orderByChild('uid').equalTo(uid)
          .once('value').then(
          (data: DataSnapshot) => {
            this.users = data.val() ? data.val() : [];
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getAllUsers() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/').orderByChild('dateCrea')
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getSurveyors() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/').orderByChild('accountType').equalTo('SURVEYOR')
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            console.log('fail to get surveyors: ', error);
            reject(error);
          }
        );
      }
    );
  }

  getCertifiedUsers() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/').orderByChild('isCertified').equalTo(1)
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getUserSorted(size?: number, startKey?: any) {
    return new Promise(
      (resolve, reject) => {
        let ref = firebase.database().ref('/users/')
          .orderByChild('dateCrea')
          .limitToFirst(size);
        if (startKey) {
          ref = ref.startAt(startKey);
        }
        ref.once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getAllBugReports() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/rapports/').orderByChild('dateCrea')
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getAllLogs() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/adminlogs/').orderByChild('date').limitToLast(100)
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  getAllClients() {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/').orderByChild('profil')
          .once('value').then(
          (data: DataSnapshot) => {
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  signInWithLinkedIN(): void {
    //this.authService.signIn(LinkedinLoginProvider.PROVIDER_ID);
  }

  // Get a key for a new Etude and save it. users
  createNewUser(user: any) {
    const updates = {};
    // user.uid = uid;
    updates['/users/' + user.uid] = user;
    return firebase.database().ref().update(updates);
  }

  getSingleUser(uid: string) {
    return new Promise(
      (resolve, reject) => {
        firebase.database().ref('/users/' + uid).once('value').then(
          (data: DataSnapshot) => {
            this.user = data.val();
            resolve(data.val());
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  saveLog(adminlog: any) {
    const uid = firebase.database().ref().child('adminlogs/').push().key;
    const updates = {};
    adminlog.uid = uid;
    updates['/adminlogs/' + uid] = adminlog;
    return firebase.database().ref().update(updates);
  }

  editBug(bug: any) {
    const updates = {};
    updates['/rapports/' + bug.uid] = bug;
    return firebase.database().ref().update(updates);
  }

  editUser(user: UserModel) {
    const updates = {};
    updates['/users/' + user.uid] = user;
    this.user = user;
    return firebase.database().ref().update(updates);
  }

  createProspect(client: any) {
    const uid = firebase.database().ref().child('backup-prospects/').push().key;
    const updates = {};
    client.uid = uid;
    updates['/backup-prospects/' + uid] = client;
    return firebase.database().ref().update(updates);
  }

  createClient(client: any) {
    const uid = firebase.database().ref().child('clients/').push().key;
    const updates = {};
    client.uid = uid;
    updates['/clients/' + uid] = client;
    return firebase.database().ref().update(updates);
  }

  edit(user: any, uidEtude, stat: any) {
    const updates = {};
    updates['/users/' + user.uid + '/stats/' + uidEtude] = stat;
    return firebase.database().ref().update(updates);
  }

  saveUserToAuhtentification(email: string, password: string) {
    const createUser = firebase.functions().httpsCallable('createUser');

    createUser({email, password})
      .then((user: any) => {
          const updates = {};
          updates['/usersAUthen/' + user.uid] = user;
          console.log('user');
          return firebase.database().ref().update(updates);
        }
      )
      .catch(console.error);
  }

  uploadFileImage(file: File) {
    return new Promise(
      (resolve, reject) => {
        const almostUniqueFileName = Date.now().toString();
        console.log('file.name…', file.name);
        const upload = firebase.storage().ref('users')
          .child(almostUniqueFileName + file.name).put(file);
        upload.on(firebase.storage.TaskEvent.STATE_CHANGED,
          () => {
            console.log('Chargement…');
          },
          (error) => {
            console.log('Erreur de chargement ! : ' + error);
            reject();
          },

          function () {
            firebase.storage().ref('users').child(almostUniqueFileName + file.name).getDownloadURL().then(function (downloadURL) {
              // console.log('Chargé !', firebase.storage().ref().getDownloadURL());
              resolve(downloadURL);
            });
          }
        );
      }
    );
  }

  public downloadFile(user: string, filename: string): void {
    firebase.storage().ref().child(`users/${user}/${filename}`)
      .getDownloadURL().then((url) => {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = (event) => {
        /* Create a new Blob object using the response
        *  data of the onload object.
        */
        // https://firebasestorage.googleapis.com/v0/b/looka-643f2.appspot.com/o/users%2F1595861452041DSC_2800.JPG?alt=media&token=6187e467-90b6-457d-8656-a83614448f88
        const blob = new Blob([xhr.response], {type: 'image/jpg'});
        const a: any = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        console.log('success');
      };
      xhr.open('GET', url);
      xhr.send();
    }).catch(function (error) {
      // Handle any errors
      console.log(error);
    });
  }


  // Archive user
  archiveUser(user: UserModel) {
    const updates = {};
    updates['/archivedUsers/' + user.uid] = user;
    updates['/users/' + user.uid] = null;
    return firebase.database().ref().update(updates);
  }
  archiveDuplicatedUser(user: UserModel) {
    const updates = {};
    updates['/archivedDuplicatedUsers/' + user.uid] = user;
    updates['/archivedDuplicatedUsers/' + user.uid] = null;
    return firebase.database().ref().update(updates);
  }

  // Delete user
  deleteUser(user: UserModel) {
    const updates = {};
    updates['/users/' + user.uid] = null;
    return firebase.database().ref().update(updates);
  }

  deleteUserById(userId: string) {
    const updates = {};
    updates['/users/' + userId] = null;
    return firebase.database().ref().update(updates);
  }
}
